module.exports = __webpack_public_path__ + "static/img/grape.63ed57f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/grape.jpg
// module id = /d+M
// module chunks = 1